import { render, staticRenderFns } from "./SliderVideo.vue?vue&type=template&id=12a2ab74"
import script from "./SliderVideo.vue?vue&type=script&lang=js"
export * from "./SliderVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports